import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";

export default function CustomersHighlight(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  const partnersList = [
    { name: "Ministry of Community Development, Gender, Women and Special Groups", country: "Tanzania", initials: "MC" },
    { name: "Tanzania Foundation for Civil Society", country: "Tanzania", initials: "RS" },
    { name: "U.S. System of Award Management ", country: "USA", initials: "SAM" },
    
  ];

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">{getInlineLoader()}</div>
    );
  }

  return (
    <div
      className="MainBodySection bg-background"
      style={{ paddingTop: "50px" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12 mb-5">
						<h6
							className="main-section-title mb-5"
						>
							RECOGNIZED WORLD-WIDE BY:
						</h6>
          </div>

          <div className="col-md-12">
            <div className="partners-slider-wrapper position-relative overflow-hidden">
              <div className="partners-slider d-flex align-items-center">
                {[...partnersList, ...partnersList].map((partner, i) => (
                  <div
                    key={i}
                    className="partner-card text-center mx-3 flex-shrink-0"
                    style={{ 
											width: "240px",
										}}
                  >
                    <div
                      className="partner-logo d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2"
                      style={{
                        width: "80px",
                        height: "80px",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "18px",
                        background: `linear-gradient(135deg, hsl(${(i * 40) % 360}, 70%, 50%), hsl(${(i * 40 + 60) % 360}, 70%, 60%))`,
                      }}
                    >
                      {partner.initials}
                    </div>
                    <div className="fw-medium font-bold">
											<h6
												style={{
													whiteSpace: "normal",
													wordBreak: "break-word",
													lineHeight: "1.3",
												}}
											>
												{partner.name}
											</h6>
										</div>
                    <div className="text-muted small">{partner.country}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-md-12 text-center p-5">
            <h5 className="font-bold text-muted my-5">
              These legal and institutional framework enhance the organization’s credibility and positions it for strategic partnerships with government, donors, private sector, and civil society actors.
            </h5>
            <hr className="mt-5" />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideLeft {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .partners-slider {
          animation: slideLeft 25s linear infinite;
          width: max-content;
        }

        .partners-slider-wrapper {
          white-space: nowrap;
        }

        @media (max-width: 768px) {
          .partners-slider { animation-duration: 35s; }
        }

        @media (prefers-reduced-motion: reduce) {
          .partners-slider { animation: none; }
        }
      `}</style>
    </div>
  );
}
